import { cn } from '@/ui/utils';
import { CommandIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';

function Kbd({ className, ...props }: React.ComponentProps<'kbd'>) {
  return (
    <kbd
      className={cn(
        "pointer-events-none inline-flex h-5 min-w-5 select-none items-center justify-center gap-1 rounded bg-surface-3 px-1 font-medium font-sans text-xs [&_svg:not([class*='size-'])]:size-3.5",
        className,
      )}
      data-slot="kbd"
      {...props}
    />
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<'kbd'>) {
  return (
    <kbd
      className={cn('inline-flex items-center gap-1', className)}
      data-slot="kbd-group"
      {...props}
    />
  );
}

function KbdCommand({ className: _className, ...props }: React.ComponentProps<typeof Kbd>) {
  const isMac = navigator.userAgent.toLowerCase().includes('mac');
  return (
    <Kbd {...props}>
      {isMac ? <Icon data-slot="kbd-command-icon" icon={CommandIcon} /> : 'Ctrl'}
    </Kbd>
  );
}

export { Kbd, KbdGroup, KbdCommand };
